import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Camera, CameraResultType, CameraSource, Photo } from '@capacitor/camera';
import { ActionSheetController, AlertController, ModalController, Platform, PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PlatformService } from 'src/app/platform.service';
import { DataService } from 'src/app/services/data.service';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { map } from 'rxjs/operators';
import { ToastService } from 'src/app/services/toast.service';
import { LoaderService } from 'src/app/services/loader.service';
import { FormSubmissionPage } from 'src/app/modals/form-submission/form-submission.page';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { FormDescriptionPopoverComponent } from 'src/app/popovers/form-description-popover/form-description-popover.component';

const IMAGE_DIR = 'stored-images';
@Component({
  selector: 'app-form',
  templateUrl: './form.page.html',
  styleUrls: ['./form.page.scss'],
})
export class FormPage implements OnInit {
  @Input() id
  @Input() title
  form=undefined
  formGroup:FormGroup= new FormGroup({})
  @ViewChild('filepicker',{ static: false }) picker:ElementRef;
  files: any[] = [];
  loaded=false
  width = window.innerWidth;
  constructor(
    private popoverController: PopoverController,
    private errorhandlerSRV:ErrorHandlerService,
    private toastSRV:ToastService,
    private plt: Platform,
    public changeDetectorRef: ChangeDetectorRef,
    private alertController: AlertController,
    private translate: TranslateService,
    private actionSheetCtrl: ActionSheetController,
    private fb: FormBuilder,
    private modalCtrl:ModalController,
    public dataSRV:DataService,
    private loaderService:LoaderService,
    private platformSRV:PlatformService
  ) { }

  // otherCheckbox(formItemname){
  //  console.log(this.formGroup.controls[formItemname]['controls']['other'].setValue(""));
  // }
  async presentDescriptionPopover(e: Event,description) {
      const popover = await this.popoverController.create({
        component: FormDescriptionPopoverComponent,
        componentProps:{description},
        event: e,
      });
  
      await popover.present();
  
      const { role } = await popover.onDidDismiss();
    }
  incrementNumber(formItem){
    if(!formItem.min){
      formItem.min =0
    }
    if(!this.formGroup.controls[formItem.name].value){
      this.formGroup.controls[formItem.name].setValue(formItem.min)
    }
     if((this.formGroup.controls[formItem.name].value+formItem.step<=formItem.max) || !formItem.max){
      this.formGroup.controls[formItem.name].setValue(this.formGroup.controls[formItem.name].value+formItem.step)
    }
  }
  decrementNumber(formItem){
    if(!formItem.min){
      formItem.min =0
    }
    if(!this.formGroup.controls[formItem.name].value){
      this.formGroup.controls[formItem.name].setValue(formItem.min)
    }
    if(this.formGroup.controls[formItem.name].value-formItem.step>=formItem.min){
      this.formGroup.controls[formItem.name].setValue(this.formGroup.controls[formItem.name].value-formItem.step)
    }
  }
  autoCompleteSelected(formControlName,value){
    
    this.formGroup.controls[formControlName].setValue(value)
  }
  autoCompleteInput(array,formControlName){
   
    
    var newArray = array.filter(item=>item.label.toLowerCase()==this.formGroup.controls[formControlName].value.toLowerCase().trim())
    var validator = this.formGroup.controls[formControlName].validator({} as AbstractControl)
    
    
    setTimeout(() => {
      if (validator && validator.required) {
      if(newArray.length>0){
        this.formGroup.controls[formControlName].setErrors(null)
      } else {
        this.formGroup.controls[formControlName].setErrors({incorrect: true})
      }}
      else {
        this.formGroup.controls[formControlName].setErrors(null)
      }
    }, 100);
    // this.changeDetectorRef.detectChanges()
  }
  
  radioGroupSelected(formItemName,event){
   
      this.formGroup.controls[formItemName].setValue(event.detail.value)
   
  }
  radioGroupOther(formItemName,event){
    
    this.formGroup.controls[formItemName].setValue(event.detail.value)
  }
  padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }
  formatDate(date) {
    if(date){
      date =new Date(date)
      return [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join('-');
    } else {
       return date
    }
    
   
    
  }
  ngOnInit() {
    this.dataSRV.getData(`api/v1/user/forms/`+this.id)
    .pipe(map((res:any)=>{
      res['form'].forEach(element => {
        if(element['type']=='checkbox-group'){
          this.formGroup.addControl(element['name'],new FormGroup({}))
          var group = this.formGroup.controls[element['name']] as FormGroup
          for(var i = 0;i<element['values'].length;i++){
            group.addControl(element['values'][i]['label'],new FormControl(element['values'][i]['selected']))
          }
          if(element && element['other']){
            group.addControl("other",new FormControl(""))
          }
          if(element['required']){
            group.addValidators(this.requireCheckboxesToBeCheckedValidator())
          }
          
            
        } else if(element['type']=='radio-group'){
          
          var selectedValue;
          for(var i = 0;i<element['values'].length;i++){
           if(element['values'][i]['selected']){
            selectedValue = element['values'][i]['label']
           }
          }
          
          if(element['required']){
            this.formGroup.addControl(element['name'],new FormControl(selectedValue,Validators.required))
          } else {
            this.formGroup.addControl(element['name'],new FormControl(selectedValue))
          }
        } else if(element['type']=='number'){
          this.formGroup.addControl(element['name'],new FormControl(element.value,[ Validators.min(element['min']), Validators.max(element['max'])]))
        } 
        else if(element['type']=='text' || element['type']=='textarea' || element['type']=="date"){
          this.formGroup.addControl(element['name'],new FormControl(element.value))
        } 
        else if(element['type']=='select'){
          if(element['multiple']){
            var array=[];
            for(var i = 0;i<element['values'].length;i++){
              if(element['values'][i]['selected']){
                array.push(element['values'][i]['label'])
              }
             }
             this.formGroup.addControl(element['name'],new FormControl(array))
          } else {
            for(var i = 0;i<element['values'].length;i++){
              if(element['values'][i]['selected']){
                this.formGroup.addControl(element['name'],new FormControl(element['values'][i]['value']))
              }
             }
          }
          
          
        } 
        else if(element['type']=='autocomplete'){
          if(element['required']){
            this.formGroup.addControl(element['name'],new FormControl("",[Validators.required]))
          } else {
            this.formGroup.addControl(element['name'],new FormControl(""))
          }
          

        } 
       
        
        else {
          this.formGroup.addControl(element['name'],new FormControl(""))
        }
        
      });
      
      
      this.form=res['form']
      console.log(this.form);
      this.loaded=true
      
    }
      
    ))
    .subscribe(()=>{
      
      
      
      
      
    })
  }
  requireCheckboxesToBeCheckedValidator(minRequired = 1): ValidatorFn {
    return function validate (formGroup: FormGroup) {
      let checked = 0;
  
      Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.controls[key];
       
        if (control.value !=false && control.value.toString().trim()) {
          checked ++;
        }
      });
  
      if (checked < minRequired) {
        return {
          requireCheckboxesToBeChecked: true,
        };
      }
  
      return null;
    };
  }
  requirerRadiosToBeCheckedValidator(minRequired = 1): ValidatorFn {
    return function validate (formGroup: FormGroup) {
      let checked = 0;
  
      Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.controls[key];
       
        if (control.value) {
          checked ++;
        }
      });
  
      if (checked < minRequired) {
        return {
          requireCheckboxesToBeChecked: true,
        };
      }
  
      return null;
    };
  }
  closeModal() {
    this.modalCtrl.dismiss();
  }
//   async removeFile(fileIndex){
//     const alert = await this.alertController.create({
//       header: 'Remove File?',
//       buttons: [
//         {
//           text: 'Cancel',
//           role: 'cancel',
//           handler: () => {
            
//           },
//         },
//         {
//           text: 'OK',
//           role: 'confirm',
//           handler: () => {
//             this.files.splice(fileIndex,1)
//           },
//         },
//       ],
//     });

//     await alert.present();

//   }
  
//   getFileReader(): FileReader {
//     const fileReader = new FileReader();
//     const zoneOriginalInstance = (fileReader as any)["__zone_symbol__originalInstance"];
//     return zoneOriginalInstance || fileReader;
// }
// async saveFileFromDevice(base64,type){

    
//   const fileName = new Date().getTime() + type;
//   const savedFile = await Filesystem.writeFile({
//       path: `${IMAGE_DIR}/${fileName}`,
//       data: base64,
//       directory: Directory.Data,
//       recursive:true
//   });

// this.files.push({
//   name: fileName,
//   path: `${IMAGE_DIR}/${fileName}`,
//   data: base64,
//   type:type
// });

// }
  // async fileSelected(event){
  //   var type= event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf("."))
   
  //   if(this.platformSRV.isNative.value){
  //     var fileReader = this.getFileReader()
  //      fileReader.onload = (imgsrc) => {   
  //       this.saveFileFromDevice((imgsrc.target as FileReader).result,type)            
       
  //     }
  //     fileReader.onloadend = () =>{
  //       this.picker.nativeElement.value = "";
  //       setTimeout(() => {
  //         this.changeDetectorRef.detectChanges();
  //       }, 250);
        
  //     }
      
  //     fileReader.readAsDataURL(event.target.files[0])
     
      
  //   }
  //   else {
  //     var fileReader = new FileReader();
  //     fileReader.readAsDataURL(event.target.files[0])
  //     fileReader.onload = () => {
       
      
  //       this.saveFileFromDevice(fileReader.result,type)
        
        
  //     }
  //     fileReader.onloadend = () =>{
  //       this.picker.nativeElement.value = "";
  //       setTimeout(() => {
  //         this.changeDetectorRef.detectChanges();
  //       }, 250);
        
  //     }
      
     
  //   }

    
    
  // }
  // convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
  //   const reader = new FileReader;
  //   reader.onerror = reject;
  //   reader.onload = () => {
  //       resolve(reader.result);
  //   };
  //   reader.readAsDataURL(blob);
  // });
  // private async readAsBase64(photo: Photo) {
  //   if (this.plt.is('hybrid')) {
  //       const file = await Filesystem.readFile({
  //           path: photo.path
  //       });
  
  //       return file.data;
  //   }
  //   else {
  //       // Fetch the photo, read as a blob, then convert to base64 format
  //       const response = await fetch(photo.webPath);
  //       const blob = await response.blob();
  
  //       return await this.convertBlobToBase64(blob) as string;
  //   }
  // }
  // async saveImageFromCamera(file) {
 
  //   if(this.platformSRV.isNative.value){
  //   const base64Data = await this.readAsBase64(file);
  //   const fileName = new Date().getTime() + '.' + file.format;
  //   const savedFile = await Filesystem.writeFile({
  //       path: `${IMAGE_DIR}/${fileName}`,
  //       data: base64Data,
  //       directory: Directory.Data,
  //       recursive:true
  //   });
  
  // this.files.push({
  //   name: fileName,
  //   path: `${IMAGE_DIR}/${fileName}`,
  //   data: 'data:image/jpeg;base64,' + base64Data,
  // });}
  // else {
  //   const base64Data = await this.readAsBase64(file);
  //   const fileName = new Date().getTime() + '.' + file.format;
  //   const savedFile = await Filesystem.writeFile({
  //       path: `${IMAGE_DIR}/${fileName}`,
  //       data: base64Data,
  //       directory: Directory.Data,
  //       recursive:true
  //   });
  
  // this.files.push({
  //   name: fileName,
  //   path: `${IMAGE_DIR}/${fileName}`,
  //   data: base64Data,
  // });
  // }
  
   
  // }
//   async selectFile() {
    
//     const actionSheet = await this.actionSheetCtrl.create({
//       header: this.translate.instant('keys.data.profile.select_files_to_upload'),
//       mode:"ios",
//       buttons:[
//         {
//           text:this.translate.instant('keys.data.profile.from_device'),
//           icon:"folder",
//           handler:(async ()=>{
//            this.picker.nativeElement.click()
           
//           }) 
//           ,
          
//         },
//         {
//           text:this.translate.instant('keys.data.profile.from_camera'),
//           icon:"camera",
//           handler:(async ()=>{
//             const image = await Camera.getPhoto({
//               quality: 90,
//               allowEditing: false,
//               resultType: CameraResultType.Uri,
//               source: CameraSource.Camera 
//           })
//           if(image){
//             this.saveImageFromCamera(image)
//           }
            
//           })
//           ,
          
//         },
//         {
//           text: this.translate.instant('keys.data.common.cancel'),
//           role: 'cancel',
//           data: {
//             action: 'cancel',
//           },
//         }
//       ]
//     })
//   actionSheet.present()
    
// }
async submitForm(){
  const alert = await this.alertController.create({
    header: 'Submit form?',
    buttons: [
      {
        text: 'Cancel',
        role: 'cancel',
        handler: () => {
         
        },
      },
      {
        text: 'Submit',
        role: 'confirm',
        handler: () => {
          this.loaderService.showLoader('loading')
          for (const key in this.formGroup.value) {
            this.form.forEach(element => {
              if(element['name']==key){
                if(element['type']=='checkbox-group'){
                  element['values'].forEach(checkBoxElement=>{
                    
                    for (const innerKey in this.formGroup.value[key]) {
                      if(checkBoxElement['label']==innerKey){
                        checkBoxElement['selected']=this.formGroup.value[key][innerKey]
                      }
                    }
                   
                  })
                } else if(element['type']=='radio-group'){
                  element['values'].forEach(radioElement=>{
                    
                      if(radioElement['label']==this.formGroup.value[key]){
                        radioElement['selected']=true
                      } else {
                        radioElement['selected']=false
                      }
                    
                  })
                }
                else if(element['type']=='autocomplete'){
                  element['values'].forEach(autoCompleteElement=>{
                    
                      if(autoCompleteElement['label']==this.formGroup.value[key]){
                        autoCompleteElement['selected']=true
                      } else {
                        autoCompleteElement['selected']=false
                      }
                    
                  })
                }
                else if(element['type']=='autocomplete'){
                  element['values'].forEach(autoCompleteElement=>{
                    
                      if(autoCompleteElement['label']==this.formGroup.value[key]){
                        autoCompleteElement['selected']=true
                      } else {
                        autoCompleteElement['selected']=false
                      }
                    
                  })
                }
                else if(element['type']=='select'){
                  if(element['multiple']){
                  element['values'].forEach(selectElement=>{
                    if(this.formGroup.value[key].length>0){
                      for(var i=0;i<this.formGroup.value[key].length;i++){
                        if(selectElement['label']==this.formGroup.value[key][i]){
                          selectElement['selected']=true
                          break
                        }
                        if(i==this.formGroup.value[key].length-1){
                          selectElement['selected']=false
                        }
                      }
                    } else {
                      selectElement['selected']=false
                    }
                    
                    
                  })} else {
                    element['values'].forEach(selectElement=>{
                      if(selectElement['label']==this.formGroup.value[key]){
                        selectElement['selected']=true
                      } else {
                        selectElement['selected']=false
                      }
                    })
                  }
                } else if(element['type']=="date"){
                  element['value']=this.formatDate(this.formGroup.value[key])
                }
                
                else {
                  element['value']=this.formGroup.value[key]
                }
               
              }
            });
            
          }
          
        
          var data = { "data":this.form}
          this.dataSRV.postData('api/v1/user/forms/' + this.id + '/submit',data).subscribe({
            next:response=>{
              this.loaderService.dismissLoader()
              if(response['status']=='success'){
                if(response['show_results_back']=="on"){
                  this.toastSRV.presentToast(response['message'])
                  this.modalCtrl.dismiss().then(async data=>
                    {
                      const desktopModal = await this.modalCtrl.create({
                        component: FormSubmissionPage,
                        backdropDismiss:false,
                        breakpoints: [0.5, 0.8,1],
                        initialBreakpoint: 1,
                        cssClass: 'modal-desktop-long',
                        componentProps:{
                          results:response['submission_results'],
                        }
                      });
                      const mobileModal = await this.modalCtrl.create({
                        component: FormSubmissionPage,
                        breakpoints: [0.5, 0.8,1],
                        backdropDismiss:false,
                        initialBreakpoint: 1,
                        cssClass:"modal-mobile-normal",
                        componentProps:{
                          results:response['submission_results'],
                        }
                      })
                      const tabletModal = await this.modalCtrl.create({
                        component: FormSubmissionPage,
                        backdropDismiss:false,
                        breakpoints: [0.5, 0.8,1],
                        initialBreakpoint: 1, 
                        cssClass:"modal-tablet-normal",
                        componentProps:{
                          results:response['submission_results'],
                        }
                      })
                      if(this.platformSRV.device=='desktop'){
                        return await desktopModal.present();
                      } else if(this.platformSRV.device=='mobile'){
                        return await mobileModal.present();
                      } else if(this.platformSRV.device=='tablet'){
                        return await tabletModal.present();
                      }
                    })
                } else {
                  this.toastSRV.presentToast(response['message'])
                  this.modalCtrl.dismiss()
                }
               
              } else {
                this.toastSRV.presentErrorToast(response['message'])
              }
            },
            error:error=>{
              this.errorhandlerSRV.displayErrorMessage(error,true)
            }
            
            
          })
        },
      },
    ],
  });
  await alert.present()
}
}